export const playerStates = {
  new: 'NEW',
  resume: 'RESUME',
  running: 'RUNNING',
  completed: 'COMPLETED',
  restrospect: 'RETROSPECT',
  ended: 'ENDED',
  results: 'RESULTS'
};
